export const STATSIG_EVENT_NAMES = {
    CHECKOUT_ALL_CART_SUMMARY_CLICK: 'Checkout - All - Click - Cart Summary',
    CHECKOUT_ALL_SUCCESS_ABANDON_ORDER:
        'Checkout - All - Sucsess - Abandon Order',

    CHECKOUT_STEP_ORDER_SUCCESS:
        'Checkout - Checkout Step - Success - Place Order',
    CHECKOUT_STEP_PAGE_VIEW: 'Checkout - Checkout Step - View - Page',
    CHECKOUT_STEP_PLACE_ORDER_CLICK:
        'Checkout - Checkout Step - Click - Place Order',
    CHECKOUT_STEP_ORDER_CONFIRMATION_VIEW_PAGE:
        'Checkout - Order Confirmation Step - View - Page',
    CHECKOUT_STEP_ORDER_CONFIRMATION_VIEW_TICKETS:
        'Checkout - Order Confirmation Step - Click - View Tickets',

    CHECKOUT_STEP_SUCCESS_ORGANIZER_QUESTIONS_RATIO:
        'Checkout - Order Form - Success - Organizers Questions Submitted',
    CHECKOUT_STEP_ORGANIZER_QUESTIONS_VIEW:
        'Checkout - Organizer Additional Questions - View - Page',
    CHECKOUT_STEP_ORGANIZER_QUESTIONS_CLICK:
        'Checkout - Organizer Additional Questions - Click - Submit CTA',

    CHECKOUT_STEP_QUESTIONS_MODAL_VIEW:
        'Checkout - Checkout Step - View - Questions Modal',
    CHECKOUT_STEP_QUESTIONS_MODAL_CLICK:
        'Checkout - Checkout Step - Click - Questions Modal CTA',
    CHECKOUT_STEP_QUESTIONS_MODAL_CLOSE:
        'Checkout - Checkout Step - Click - Questions Modal Close',
    CHECKOUT_STEP_BACK_CLOSED_AFTER_TOS:
        'Checkout - Checkout Step - Click - Abandon Order ToS',

    TICKET_STEP_PAGE_VIEW: 'Checkout - Ticket Selection Step - View - Page',
    TICKET_STEP_CONTINUE_TO_PAYMENT_CLICK:
        'Checkout - Ticket Selection Step - Click - Continue to payment',
    TICKET_STEP_VALIDATION_ERROR_VIEW:
        'Checkout - Ticket Selection Step - View - Validation Error',
    TICKET_SELECTION_STEP_REMOVE_PROMO_CODE:
        'Checkout - Ticket Selection Step - Click - Remove Promo Code',
    TICKET_SELECTION_STEP_APPLY_PROMO_CODE:
        'Checkout - Ticket Selection Step - Click - Apply Promo Code',
    TICKET_SELECTION_STEP_ERROR_PROMO_CODE:
        'Checkout - Ticket Selection Step - View - Promo Code Error',
    TICKET_SELECTION_COMPACT_STEP_MORE_INFO_CLICK:
        'Listing - Conversion Bar - More info Button - Change - Compact Ticket Selection',
    LOGIN_STEP_PAGE_VIEW: 'Checkout - Login Step - View - Page',
    LOGIN_STEP_SUCCESS_LOGIN: 'Checkout - Login Step - Success - Button Login',
};

const TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER =
    'checkout_ticket_selection_page_experiments';
const ORDER_FORM_PAGE_EXPERIMENTS_LAYER = 'checkout_checkout_page_experiments';

export enum TicketsFormat {
    listItem = 'listItem',
    card = 'card',
}

export const URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT = {
    defaultValue: false,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'urgency_signals_visible',
};

export const SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT = {
    defaultValue: false,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'scrollable_cta',
};

export const APPLE_PAY_ON_LISTINGS_PAGE_EXPERIMENT = {
    defaultValue: false,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'applepay_listings',
};

export const EXPRESS_PAYPAL_ON_TICKET_SELECTION_PAGE_EXPERIMENT = {
    defaultValue: false,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'express_paypal_available',
};

export enum PlaceOrderAndTosVariant {
    ctaOnStickyFooter = 'ctaOnStickyFooter',
    scrollableCtaTos = 'scrollableCtaTos',
    scrollableWithoutTosCheckbox = 'scrollableWithoutTosCheckbox',
}

export const COPY_INFORMATION_CHECKBOX_ORDER_FORM_EXPERIMENT = {
    defaultValue: false,
    layer: ORDER_FORM_PAGE_EXPERIMENTS_LAYER,
    param: 'copy_info_ckeckbox_visible',
};

export const SHORT_TOS_TEXT_ORDER_FORM_EXPERIMENT = {
    defaultValue: false,
    layer: ORDER_FORM_PAGE_EXPERIMENTS_LAYER,
    param: 'show_short_ToS_text',
};

export const SCROLLABLE_CTA_TOS_ON_ORDER_FORM_EXPERIMENT = {
    defaultValue: PlaceOrderAndTosVariant.ctaOnStickyFooter,
    layer: ORDER_FORM_PAGE_EXPERIMENTS_LAYER,
    param: 'place_order_tos_variant',
};

// Important: Don't forget to add any new experiment to this object.
// This object is used by Cypress to force control in all experiments by default.
// If you don't add new experiments to this object, tests will become flaky when the experiment starts.
export const STATSIG_PARAMETERS_FOR_ALL_EXPERIMENTS_IN_CONTROL = {
    [EXPRESS_PAYPAL_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param]:
        EXPRESS_PAYPAL_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
    [SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param]:
        SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
    [APPLE_PAY_ON_LISTINGS_PAGE_EXPERIMENT.param]:
        APPLE_PAY_ON_LISTINGS_PAGE_EXPERIMENT.defaultValue,
    [URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param]:
        URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
    [COPY_INFORMATION_CHECKBOX_ORDER_FORM_EXPERIMENT.param]:
        COPY_INFORMATION_CHECKBOX_ORDER_FORM_EXPERIMENT.defaultValue,
    [SHORT_TOS_TEXT_ORDER_FORM_EXPERIMENT.param]:
        SHORT_TOS_TEXT_ORDER_FORM_EXPERIMENT.defaultValue,
    [SCROLLABLE_CTA_TOS_ON_ORDER_FORM_EXPERIMENT.param]:
        SCROLLABLE_CTA_TOS_ON_ORDER_FORM_EXPERIMENT.defaultValue,
};
